import { z } from 'zod';

export const getCommentFormSchema = () => {
  return z.object({
    content: z.string().optional(),
  });
};

export type CommentFormData = z.infer<ReturnType<typeof getCommentFormSchema>>;
